export class CostReviewEnUsToolsSa {
    specialToolsRequired: number = 0;
    costForSpecialTools: number = 0;
}